export const SESSION_RENEWED_EVENT = 'signup-session-renewed';
